import SMS from './index.vue';

export default SMS;